import { useCallback } from 'react';
import { useRequest } from '@Hooks';
import { API } from '@Services';

export const useCreateMatchmakingApplyFundNonProfitLink = () => {
  const [fetch, response] = useRequest();

  const createMatchmakingApplyFundNonProfitLink = useCallback(
    (fundId: number) => fetch(API.paths.matchmaking_apply_create_non_profit_link(fundId), 'post'),
    [fetch],
  );

  return [createMatchmakingApplyFundNonProfitLink, response] as const;
};
